import styled from "styled-components";
import Portal from "./Portal";
import theme from "../common/theme";
import { forwardRef, useEffect } from "react";

const ModalContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;    
    left: 0;
    bottom: 0;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.7);
    z-index: ${props => props.zindex || '1000'};
    `;

const ModalBody = styled.div`
    display: flex;
    background-color: white; //${theme.palette.blue};
    border: 1px solid white; //${theme.palette.blue};
    color: black;
    width: ${props => props.size ? props.size : '88%'};
    padding: 2rem;
    // border-radius: 2rem;
    max-height: 90%;
    flex-direction: column;
    gap: 1rem;
    // margin-top: 100px;
    overflow-x: hidden;
    overflow-y: auto;

    @media (max-width: 768px) {
        width: 90%;
        padding: 1rem;
    }
`;

export const ModalDivider = styled.hr`
    width: 100%;
    border: 1px solid ${theme.palette.border};
`

export const Footer = styled.div`
    display: flex;
    gap: 0.5rem;
    flex-direction: row;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid ${theme.palette.border}
`

const Modal = forwardRef(({ show, children, onClose, size, bodyStyle, containerStyle, closeOnEscape = false, zindex }, ref) => {
    useEffect(() => {
        const listener = (e) => {
            if (e.key === 'Escape' && closeOnEscape) {
                onClose();
            }
        }

        let scroll = window.scrollY;
        window.addEventListener('keyup', listener)
        window.scrollTo({ top: 0 });
        window.document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keyup', listener);
            window.document.body.style.overflow = 'auto';
            window.scrollTo({ top: scroll })
        }
    }, [])

    if (!show) {
        return null;
    }


    return (
        <Portal
            node={document.getElementsByTagName('body')[0]}
        >
            <ModalContainer onClick={onClose} zindex={zindex} style={containerStyle}>
                <ModalBody onClick={(e) => e.stopPropagation()} size={size} style={bodyStyle} ref={ref}>
                    {children}
                </ModalBody>
            </ModalContainer>
        </Portal>
    )
})

export default Modal